module.exports = angular.module('cartographer.map.inspector.photo', [])

_ = require 'underscore'

module.exports.directive 'crtPhotoInspector', $DI (crtLog, $timeout, $q, crtAttachment) ->
  return {
    restrict: 'A'
    replace: true
    scope:
      selection      : '=' # crtFeatureMapSelection
      inspectorState : '=' # crtMapInspectorState
      onBackClick    : '=' # () -> void
      onOptionsClick : '=' # () -> void
    template: require './photo.tpl.html'
    controllerAs: 'crtPhotoInspector'
    bindToController: true
    controller: $DI ($scope) ->
      crtPhotoInspector = this

      crtPhotoInspector.thumbnailUrl = crtAttachment.resolveThumbnail

      crtPhotoInspector.loading = false
      crtPhotoInspector.visibleAttachments = []

      updateVisiblePhotos = (nearby) ->
        crtLog.debug('crtPhotoInspector.updateVisiblePhotos', nearby)
        crtPhotoInspector.loading = true
        crtPhotoInspector.visibleAttachments = []
        $timeout(
          ->
            promises = _.chain(nearby)
              .map((feature) -> feature.attributes.surveyRefs)
              .flatten()
              .map((ref) -> crtAttachment.search(ref.moduleId, ref.surveyId))
              .value()

            $q.all(promises)
            .then (resultsObjects) ->
              crtPhotoInspector.loading = false
              crtPhotoInspector.visibleAttachments =
                _.chain(resultsObjects)
                .map((object) -> object.results)
                .flatten(true)
                .uniq()
                .value()
              return
            .catch ->
              crtPhotoInspector.loading = false
              return
          300
        )
        return

      $scope.$watchCollection('crtPhotoInspector.selection.nearby()', updateVisiblePhotos)
      return
  }
